import './debugpage.css';
import Page from './page';
export default class DebugPage extends Page {
    constructor(parent: HTMLElement, props: {[key: string]: string}) {
        super(parent);
    }
}